import { capitalizeFirstLetter } from 'utils-next/string'

import { FinderStageId } from './stages.types'

export function getAvailableFinderStages() {
  return Object.values(FinderStageId).map(getFinderStage)
}

export function getFinderStage(stageId: FinderStageId) {
  return {
    id: stageId,
    labelId: stageId,
    display: {
      label: getStageLabel(stageId),
    },
  }
}

export function getStageLabel(stageId: FinderStageId | string) {
  return capitalizeFirstLetter(stageId.replace(/-/g, ' '))
}
